module.exports = __webpack_public_path__ + "static/media/horticulture_nobg.0d37bc32.svg";